import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { suretyKeys } from "@/lib/query-keys";
import type { SuretyMarket } from "@/types/surety";

/** El mercado de un mes (`AAAA-MM`; sin mes, el actual) y los prospectos de hoy. */
export function useSuretyMarket(month?: string) {
  return useQuery({
    queryKey: suretyKeys.market(month),
    queryFn: async () => {
      const res = await fetchToBackend<{ data: SuretyMarket }>(
        `/surety/market${month ? `?month=${month}` : ""}`,
      );
      return res.data;
    },
  });
}
